export default class ResponseERP{

    static treat(response,json){

        if(this.#isDataNotFound(json)){
            return {
                url: response.url,
                status: 404,
                statusText: "Not Found",
                message: "Não encontrado",
                data: json.data
            }
        }

        return {
            url: response.url,
            status: response.status,
            statusText: response.statusText,
            data: this.#cleanResponseData(response,json)
        }

    }

    static #cleanResponseData(response={},json={}){

        if(this.#isDataArray(response,json)){

            if(Array.isArray(json.data)){
                return json.data.map((data) => this.#removeBadParams(data));
            }

        };

        return this.#removeBadParams(json.data);

    }

    static #isDataNotFound(json={}){

        if(json?.data == "Não encontrado" || json?.data == null){
            json.data = {};
            return true
        }

        else if(json?.data?.data?.length === 0 && json?.data?.limit === 1){
            json.data = {};
            return true;
        }

        else if(json?.data?.data?.length === 0 && json?.data?.limit !== 1){
            json.data = [];
            return true;
        }

        else if(json?.data?.data === null && json?.data?.limit !== 1){
            json.data = [];
            return true;
        }
            
        return false;

    }

    static #isDataArray(response={},json={}){

        let limit = this.#getLimit(response);

        if(Array.isArray(json?.data?.data) && limit !== 1){
            json.data = json.data.data;
            return true;
        }

        else if(Array.isArray(json?.data?.data) && limit === 1){
            json.data = json.data.data[0];
            return true;
        }

        else if(Array.isArray(json?.data) && limit !== 1){
            json.data = json.data;
            return true;
        }

        else if(Array.isArray(json?.data) && limit === 1){
            json.data = json.data[0];
            return true;
        }
    
        return false;

    }

    static #getLimit(response){

        const url = new URL(response.url);
        const searchParams =  new URLSearchParams(url.search);
        const limit = parseInt( searchParams.get("limit") || 1 );
        return limit;

    }

    static #removeBadParams(data={}){

        if(data?.Id){
            data.id = data.Id;
        }
    
        delete data.CreateAt;
        delete data.CreateBy;
        delete data.UpdateAt;
        delete data.UpdateBy;
        delete data.DeleteAt;
        delete data.DeleteBy;
        delete data.IsDeleted;
        delete data.Id;
    
        delete data.createAt;
        delete data.createBy;
        delete data.updateAt;
        delete data.updateBy;
        delete data.deleteAt;
        delete data.deleteBy;
        delete data.isDeleted;
    
        return data;

    }

}